import { CommonValue } from "./CommonValue";
import { CounterOrderSection } from "./CounterOrderSection";

class CurrentPregnancy extends CounterOrderSection {
    public Remarks: string;
    public NauseaAndVomiting: CommonValue;
    public Constipation: CommonValue;
    public RGO: CommonValue;
    public Edema: CommonValue;
    public Headaches: CommonValue;
    public VaginalDischarge: CommonValue;
    public Bleeding: CommonValue;
    public AbdominalPain: CommonValue;
    public UrinarySymptoms: CommonValue;

    constructor(fields?: Partial<CurrentPregnancy>) {
        super();
        Object.assign(this, fields);
        this.NauseaAndVomiting = new CommonValue(fields?.NauseaAndVomiting);
        this.Constipation = new CommonValue(fields?.Constipation);
        this.RGO = new CommonValue(fields?.RGO);
        this.Edema = new CommonValue(fields?.Edema);
        this.Headaches = new CommonValue(fields?.Headaches);
        this.VaginalDischarge = new CommonValue(fields?.VaginalDischarge);
        this.Bleeding = new CommonValue(fields?.Bleeding);
        this.AbdominalPain = new CommonValue(fields?.AbdominalPain);
        this.UrinarySymptoms = new CommonValue(fields?.UrinarySymptoms);
    }
}

export { CurrentPregnancy };
